import React from "react";
import backgroundSvg from "../svgs/background.svg";
// import heroSvg from '../svgs/heroSvg.svg'
import heroDotted from "../svgs/heroDotted.svg";
import Typist from "react-typist";

function HeroPage() {
  return (
    <div className="h-screen flex flex-col justify-center items-center relative  " >
      <p className="text-4xl sm:text-6xl hero__heading -mt-40 sm:-mt-20 text-blue-700 opacity-70 animate-bounce" data-aos="fade-left" data-aos-delay="1500" id="main__heading">
        Sawan Mehra
      </p>

      <Typist>
        <p className="text-2xl text-center sm:text-5xl mt-6 font-semibold" >
          Full-Stack Developer & UI/UX Designer
        </p>
      </Typist>
      <img
        src={backgroundSvg}
        alt=""
        className="absolute left-0 opacity-10 animate-spin sm:-top-36 top-32"
      />
      <img
        src={heroDotted}
        alt=""
        className="-left-96 absolute opacity-10 hidden sm:flex "
      />
      <img
        src={heroDotted}
        alt=""
        className="absolute opacity-40 sm:opacity-10 animate-bounce"
      />
      <img
        src={heroDotted}
        alt=""
        className="-right-96 absolute opacity-10 hidden sm:flex "
      />
    </div>
  );
}

export default HeroPage;
